/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: useDebounce hook for debouncing input

Author: Deimos Space UK

Version: 1.0
*/
import {useState, useEffect} from 'react';

const useDebounce = (val , delay) => {
    const [debouncedValue, setDebouncedValue] = useState(val);
    
    useEffect(() => {
        const handler = setTimeout(() => {
        setDebouncedValue(val);
        }, delay);
    
        return () => {
        clearTimeout(handler);
        };
    }, [val, delay]);
    
    return debouncedValue;
    }

export default useDebounce;